module.exports = __webpack_public_path__ + "media/images/icons/country_flags/mm-82321f19830e8de129b7e0272961caed.svg";